import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { EmployeeImportEnqueueResponse } from '../../employee.model';
import { EmployeeImportStatus } from '../../employee.store';

export type EmployeeImportSubmitEvent = {
  file: File;
  idempotencyKey: string;
};

@Component({
  selector: 'employee-import',
  imports: [...SharedMaterialUIModule],
  templateUrl: './employee-import.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EmployeeImportComponent {
  readonly busy = input(false);
  readonly status = input<EmployeeImportStatus>('idle');
  readonly result = input<EmployeeImportEnqueueResponse | null>(null);
  readonly imported = output<EmployeeImportSubmitEvent>();
  readonly retryRequested = output<void>();

  protected onFileSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file = target.files?.item(0);
    if (!file) {
      return;
    }

    this.imported.emit({
      file,
      idempotencyKey: crypto.randomUUID(),
    });

    target.value = '';
  }

  protected clearSelection(input: HTMLInputElement): void {
    try {
      input.value = '';
    } catch {
      // ignore
    }
  }

  protected retry(): void {
    this.retryRequested.emit();
  }
}
